import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { logEvent } from "firebase/analytics";
import { analytics } from "./analytics"; // adjust path if needed


function AccountSettings() {
  const navigate = useNavigate();
  const user = auth.currentUser;

useEffect(() => {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.setUserEmail &&
    user?.email
  ) {
    window.webkit.messageHandlers.setUserEmail.postMessage(user.email);
  }
}, [user]);


const [prefs, setPrefs] = useState({
  career: true,
  community: true,
  account: true,
  product: false
});
  useEffect(() => {
    if (!user) return;

    const loadPreferences = async () => {
      try {
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);

        if (snap.exists() && snap.data().notificationPreferences) {
          setPrefs(snap.data().notificationPreferences);
        } else {
          // Initialize defaults if missing
          await updateDoc(ref, {
            notificationPreferences: {
              career: true,
              community: true,
              account: true,
              product: false
            }
          });
        }
      } catch (err) {
        console.error("Failed to load notification preferences:", err);
      } finally {
        setLoadingPrefs(false);
      }
    };

    loadPreferences();
  }, [user]);
  const updatePreference = async (key) => {
    if (!user) return;

    const updated = {
      ...prefs,
      [key]: !prefs[key]
    };

    setPrefs(updated);

    try {
      await updateDoc(doc(db, "users", user.uid), {
        notificationPreferences: updated
      });
    } catch (err) {
      console.error("Failed to update preferences:", err);
    }
  };

  const handleDeleteClick = () => {
  logEvent(analytics, "delete_account_clicked", {
    location: "account_settings",
  });

  navigate("/support/delete-account");
};


const [loadingPrefs, setLoadingPrefs] = useState(true);


  return (
   <div
  style={{
    minHeight: "100vh",
    backgroundColor: "#4A4A8A",
    padding: "60px 16px",
  }}
>
  <div
    style={{
      maxWidth: "600px",
      margin: "0 auto",
      padding: "28px",
      backgroundColor: "#ffffff",
      color: "#1f2937",
      borderRadius: "14px",
      boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
    }}
  >
    <h2 style={{ marginBottom: "20px" }}>Account Settings</h2>

    <div style={{ marginBottom: "20px" }}>
      <p>
        <strong>Email:</strong> {user?.email}
      </p>
    </div>

    <hr style={{ margin: "28px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

    {/* Resume Library */}
    <section>
      <h3>📁 Resume Library</h3>
      <p>Manage and download your saved resumes here.</p>
      <button
  style={{
    backgroundColor: "#4A4A8A",
    color: "#ffffff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    marginTop: "12px",
  }}
  onClick={() => navigate("/resume-library")}
>
  View My Resumes
</button>

    </section>

    <hr style={{ margin: "28px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

    {/* Notifications */}
    <section>
      <h3>🔔 Notification Preferences</h3>

      {loadingPrefs ? (
        <p>Loading preferences…</p>
      ) : (
        <>
          <label style={{ display: "block", marginBottom: "8px" }}>
            <input
              type="checkbox"
              checked={prefs.career}
              onChange={() => updatePreference("career")}
            />{" "}
            Career activity (resumes, LinkedIn profiles)
          </label>

          <label style={{ display: "block", marginBottom: "8px" }}>
            <input
              type="checkbox"
              checked={prefs.community}
              onChange={() => updatePreference("community")}
            />{" "}
            Community activity (replies, mentions)
          </label>

          <label style={{ display: "block", marginBottom: "8px" }}>
            <input
              type="checkbox"
              checked={prefs.account}
              onChange={() => updatePreference("account")}
            />{" "}
            Account updates
          </label>

          <label style={{ display: "block", marginBottom: "8px" }}>
            <input
              type="checkbox"
              checked={prefs.product}
              onChange={() => updatePreference("product")}
            />{" "}
            Product updates & announcements
          </label>

          <p style={{ fontSize: "13px", color: "#6b7280", marginTop: "10px" }}>
            You can change these settings anytime.
          </p>
        </>
      )}
    </section>

    <hr style={{ margin: "28px 0", border: "none", borderTop: "1px solid #e5e7eb" }} />

    {/* Delete Account */}
    <section>
      <h3 style={{ color: "#b91c1c" }}>⚠️ Delete Account</h3>
      <p>
        Permanently delete your EmployPilot account and all associated data.
      </p>

      <button
  style={{
    backgroundColor: "#dc2626",
    color: "#ffffff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
    marginTop: "12px",
    fontWeight: 500,
  }}
  onClick={handleDeleteClick}
>
  Delete My Account
</button>
    </section>
  </div>
</div>
  );
}

export default AccountSettings;
